'use client';
import {hideDeleteModal} from '@/libs/jquery.util';
import {useTranslations} from 'next-intl';
import {useState} from 'react';

export default function DeleteBaseModal({ type, onDelete }) {
  const m = useTranslations('modal');
  const [deleting, setDeleting] = useState(false);
  
  return (
      <div className="ltn__modal-area ltn__add-to-cart-modal-area">
        <div className="modal fade" id="delete-base-modal" tabIndex="-1">
          <div className="modal-dialog modal-md">
            <div className="modal-content">
              <div className="modal-header">
                <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    // title={m('close')}
                    aria-label={m('close')}
                >
                  <span>&times;</span>
                </button>
              </div>
              {
                type != null ? (
                    <div className="modal-body delete-modal-body">
                      <div className="modal-header mb-3">{m(`type.${type}.title`)}</div>
                      <p className="modal-description">
                        {m(`type.${type}.description`)}
                      </p>
                      <div className="btn-wrapper text-end">
                        <button
                            className="btn theme-btn-3 btn-effect-1 text-uppercase"
                            disabled={deleting}
                            onClick={() => hideDeleteModal()}
                        >
                          {m('cancel')}
                        </button>
                        <button
                            className="btn theme-btn-1 btn-effect-1 text-uppercase"
                            type="submit"
                            disabled={deleting}
                            onClick={() => onDelete(setDeleting)}
                        >
                          {deleting ? m('deleting') : m('delete')}
                        </button>
                      </div>
                    </div>
                ) : ''
              }
            </div>
          </div>
        </div>
      </div>
  );
};
